<div class="row">
    <div class="col-11">
        <ng-select
            #selectElement
            [items]="people"
            bindLabel="nameLabel"
            [loading]="peopleLoading"
            loadingText="carregando..."
            (keydown)="keydownConfigAuto($event)"
            [isOpen]="isOpen"
            (search)="onSearch($event)"
            [(ngModel)]="selectedPersonId"
            (ngModelChange)="outSelect($event)"
            notFoundText="Não exitem pessoas com o nome digitado!"
            [multiple]="false"
            (clear)="clearInput()"
            placeholder="Digite o nome da pessoa.">
        </ng-select>
    </div>
    <div class="col mt-4 p-3">
        <mat-icon (click)="searchPerson()" class="pointer" matSuffix>search</mat-icon>
    </div>
</div>